// ==========================================================================
// NETWORK CONFIG - CHANGE ACTIVE_NETWORK BELOW TO SWITCH BETWEEN MAINNET/TESTNET
// ==========================================================================

export const ACTIVE_NETWORK = 'mainnet'; // <-- CHANGE HERE: 'mainnet' | 'testnet'

// ==========================================================================

export const NETWORKS = {
  mainnet: {
    chainId: 56,
    chainIdHex: '0x38',
    name: 'BNB Smart Chain',
    rpcUrls: [
      'https://bsc-dataseed.binance.org',
      'https://bsc-dataseed1.defibit.io',
      'https://bsc-dataseed1.ninicoin.io'
    ],
    blockExplorerUrls: ['https://bscscan.com'],
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18
    }
  },
  testnet: {
    chainId: 97,
    chainIdHex: '0x61',
    name: 'BNB Smart Chain',
    rpcUrls: [
      'https://data-seed-prebsc-1-s1.binance.org:8545',
      'https://data-seed-prebsc-2-s1.binance.org:8545'
    ],
    blockExplorerUrls: ['https://testnet.bscscan.com'],
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18
    }
  }
};

export const CURRENT_NETWORK = NETWORKS[ACTIVE_NETWORK];
